import template from './rw-game-poster.html';

export default {
  template,
  bindings: {
    game: '<',
  },
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-game-poster/rw-game-poster-component.js